/**


/**
 * Expand mode for {@link AccordionMenu}
 * @public
 */
export const SortDirections = {
    ascending: "ascending",
    descending: "descending"
};
export {};
//# sourceMappingURL=table.options.js.map